import { type FC, useState } from 'react';
import { toast } from 'react-toastify';
import { useAllTeams } from '@queries/fetchTeams';

import { getDocumentUrl } from '../utils/get-document-url';
import { CopyLinkModal } from '../views/CopyLinkModal';

interface CopyLinkModalControllerProps {
  handleClose: () => void;
  teamIds?: number[];
}

export const CopyLinkModalController: FC<CopyLinkModalControllerProps> = ({ handleClose, teamIds = [] }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { data: allTeams } = useAllTeams();

  const url = getDocumentUrl(window.location);
  const teamNames = allTeams?.length
    ? teamIds.map((id) => allTeams.find((team) => team.id === id)?.name).filter(Boolean)
    : undefined;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);
    } catch {
      toast.error('Unable to copy the link');
    }
  };

  return (
    <CopyLinkModal
      audience={teamNames?.join(', ')}
      isCopied={isCopied}
      onClose={handleClose}
      onCopy={handleCopy}
      url={url}
    />
  );
};
